<app-navbar [title]="isBankTransactionsTransfers() ? 'Przelewy' : 'Transakacje'">
	<button (click)="filtersOpen()" class="btn btn-warning me-2">
		<i class="fas fa-filter"></i>
	</button>
</app-navbar>

<div *ngIf="loader" id="loader">
	<span class="spinner-border spinner-grow-lg"></span>
</div>

<app-bank-transactions-filters
	(selected)="filtersSelected($event)"
	[currentOwnerName]="parameters.currentOwnerName"
	[objTypes]="objTypes"
	[types]="types"
	userFilters="bankTransactions"
></app-bank-transactions-filters>

@if (anySelected()) {
	<div class="bulk-actions-container">
		<button (click)="openBulkUpdateDialog()" class="btn btn-success link" type="button">
			Przejdź do edycji ({{ selection.selected.length }} transakcji)
		</button>
	</div>
}

<table class="table table-striped table-hover table-bank-transactions">
	<thead>
		<tr>
			<th>
				<mat-checkbox
					(change)="masterToggle()"
					[checked]="selection.hasValue() && isAllSelected()"
					[indeterminate]="selection.hasValue() && !isAllSelected()"
					color="primary"
				/>
			</th>
			<th>
				<span (click)="setSort('numberId')" [ngClass]="{ sortBy: 'ownerName' === sortKey }" id="numberId"
					>Id</span
				>
			</th>
			<th>
				<span (click)="setSort('ownerName')" [ngClass]="{ sortBy: 'ownerName' === sortKey }" id="User"
					>Użytkownik</span
				>
			</th>
			<th>
				<span (click)="setSort('date')" [ngClass]="{ sortBy: 'date' === sortKey }">Data operacji</span>
			</th>
			<th>
				<span (click)="setSort('name')" [ngClass]="{ sortBy: 'name' === sortKey }">Nazwa operacji</span>
			</th>
			<th>
				<span (click)="setSort('value')" [ngClass]="{ sortBy: 'value' === sortKey }">Kwota</span>
			</th>
			<th>
				<span (click)="setSort('quantity')" [ngClass]="{ sortBy: 'quantity' === sortKey }">Ilość</span>
			</th>
			<th colspan="2"></th>
			<th>Kraj</th>
			<th>Rodzaj</th>
			<th>Oryginał dokumentu</th>
			<th>Osoba odpowiedzialna</th>
			<th>
				<span (click)="setSort('comment')" [ngClass]="{ sortBy: 'comment' === sortKey }">Uwagi</span>
			</th>
			<th>Faktura</th>
			<th>
				<span (click)="setSort('tourismEventId')" [ngClass]="{ sortBy: 'tourismEventId' === sortKey }"
					>Wydarzenie</span
				>
			</th>
			<th>
				<span>Kategoria wydarzenia</span>
			</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of data; let i = index" [ngClass]="item.lastVisited" id="{{ item.scrollToId }}">
			<td>
				<mat-checkbox
					(change)="selection.toggle(item)"
					[checked]="selection.isSelected(item)"
					[disabled]="item.verified"
					color="primary"
				/>
			</td>
			<td>{{ item.numberId }}</td>
			<td>{{ isBankTransactionsTransfers() ? item.accountOwnerName : item.ownerName }}</td>
			<td>{{ item.date }}</td>
			<td>{{ item.name }}</td>
			<td [ngClass]="item.class">{{ item.value }} {{ item.currency }}</td>
			<td>{{ item.quantity }}</td>
			<td>
				<abbr
					class="d-flex flex-column"
					title="{{ item.userVerifiedHistoryLast?.user }} {{ item.userVerifiedHistoryLast?.date }}"
				>
					<button
						(click)="setAction(item, ActionKind.VERIFIED)"
						[disabled]="(!item.type || !item.country) && !item.verified"
						[ngClass]="{
							'btn-success': item.verified,
							'btn-outline-danger': !item.verified,
						}"
						class="btn"
					>
						Rozliczone
					</button>
					@if (item.scan_name) {
						<a (click)="displayScan(item.scan_id)" [title]="item.scan_name" class="link scan-name">{{
							item.scan_name
						}}</a>
					}
				</abbr>
			</td>
			<td>
				<abbr title="{{ item.userCalculatedHistoryLast?.user }} {{ item.userCalculatedHistoryLast?.date }}">
					<button
						(click)="setAction(item, ActionKind.CALCULATED)"
						[disabled]="!item.type || !item.verified"
						[ngClass]="{
							'btn-success': item.calculated,
							'btn-outline-danger': !item.calculated,
						}"
						class="btn"
					>
						Kalkulacja
					</button>
				</abbr>
			</td>
			<td>
				<select
					(change)="setCountry(item)"
					[(ngModel)]="item.country"
					[disabled]="item.verified"
					class="form-select"
					name="country_{{ i }}"
				>
					<option value="">(brak)</option>
					<option *ngFor="let ctr of countries" [value]="ctr.id">
						{{ ctr.name }}
					</option>
				</select>
			</td>
			<td>
				<select
					(click)="setType(item)"
					[(ngModel)]="item.type"
					[disabled]="item.verified"
					class="form-select"
					name="type_{{ i }}"
				>
					<option value="">(brak)</option>
					<option *ngFor="let opt of types" value="{{ opt.id }}">
						{{ opt.name }}
					</option>
				</select>
			</td>
			<td>
				<div class="form-check">
					<input
						(change)="setAction(item, ActionKind.ORIGINAL_DOCUMENT)"
						[(ngModel)]="item.originalDocument"
						class="form-check-input"
						name="orginal_document_{{ i }}"
						type="checkbox"
					/>
				</div>
			</td>
			<td>
				<ng-select
					(ngModelChange)="setOwnerTransaction(item, $event)"
					[closeOnSelect]="false"
					[disabled]="item.verified"
					[multiple]="false"
					[ngModel]="item.currentOwnerTransactions"
					id="currentOwnerTransactions"
					name="currentOwnerTransactions"
				>
					<ng-option *ngFor="let item of parameters.currentOwnerName" [value]="item.currentOwnerName"
						>{{ item.currentOwnerName }}
					</ng-option>
				</ng-select>
			</td>
			<td>
				{{ item.comment }}
			</td>
			<td>
				<input
					(keyup)="editFvNumber(item)"
					[(ngModel)]="item.fv_number"
					[disabled]="item.verified"
					class="form-control mb-2"
					name="fv_number_{{ i }}"
					type="text"
				/>
				<a (click)="saveFvNumber(item)" *ngIf="item.edited" class="link">Zapisz</a>
			</td>
			<td>
				@if (item.tourismEventNewId) {
					{{ item.tourismEventNewId }}
				} @else if (item.tourismEventIdName) {
					{{ item.tourismEventIdName }}
				}
			</td>
			<td>{{ item.tourismEventCategory }}</td>
			<td>
				<a [class.disabled]="item.verified" class="btn btn-primary" routerLink="./{{ item.id }}/split"
					>&raquo;</a
				>
			</td>
		</tr>
	</tbody>
</table>
<div *ngIf="data.length === 500" class="alert alert-danger" role="alert">
	Ograniczono wyświetlanie wyników do 500, użyj filtrów aby zmniejszyć ilość wyszukanych pozycji
</div>
<div class="text-start ms-2">
	Podsumowanie bez zwrotów:
	{{ this.summaryValue.out.toFixed(2) }} PLN
</div>
<div class="text-start ms-2">
	Podsumowanie (Kurs z dnia poprzedniego):
	{{ this.summaryValue.all.toFixed(2) }} PLN
</div>
